import http from './api'

const route = '/notasfiscais/'

export default {

    listarNotasFiscais: (empresaId, produtorId, dataInicio) => {
        return http.post(route + 'listar_notas', {
            produtor_id: produtorId,
            empresa_id: empresaId,
            datainicio: dataInicio,
        })
    },
    listarLaticinios: (chaveativacao) => (
        http.post(route + 'listar_empresas', { chaveativacao: chaveativacao })
    ),
    listarItensNotaFiscal: (idNotaFiscal) => {
        return http.post(route + 'listar_itens_nota_fiscal', {
            notafiscal_id: idNotaFiscal,
        })
    },
}
